export const buildWsUrl = ({ baseUrl, clientId, uploadId }) => {
  if (!clientId || !uploadId) return null
  const path = `/api/ws/lidar/${clientId}/${uploadId}/`
  const direct =
    import.meta.env.VITE_DJANGO_WS_DIRECT === 'true' &&
    import.meta.env.VITE_DJANGO_WS_URL?.trim()

  if (direct) {
    const djangoWs = import.meta.env.VITE_DJANGO_WS_URL.trim().replace(
      /\/$/,
      '',
    )
    return `${djangoWs}${path}`
  }

  if (baseUrl) {
    const parsed = new URL(baseUrl, window.location.origin)
    const wsBase = parsed.origin.replace(/^http/, 'ws')
    return `${wsBase}${path}`
  }

  const djangoWs = import.meta.env.VITE_DJANGO_WS_URL?.trim().replace(/\/$/, '')

  if (djangoWs) {
    return `${djangoWs}${path}`
  }
  return null
}

export const mapLidarProcessingPercent = backendPercent => {
  const p = Math.min(100, Math.max(0, Number(backendPercent) || 0))
  return Math.round(25 + p * 0.75)
}

export const buildDjangoHttpBase = ({ djangoUrl, djangoWsUrl }) => {
  const rawBase =
    djangoUrl || (djangoWsUrl ? djangoWsUrl.replace(/^ws/, 'http') : '')
  return rawBase ? rawBase.replace(/\/$/, '') : ''
}

export const formatDate = dateString => {
  const date = new Date(dateString)
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear()
  return `${day}/${month}/${year}`
}

export const getFileExtension = fileName => {
  const lastDot = fileName.lastIndexOf('.')
  return lastDot >= 0 ? fileName.slice(lastDot).toLowerCase() : ''
}
